import React from 'react';
import SalaryCalculator from './salary-calculator';

function App() {
  return (
    <div className="App">
      <SalaryCalculator />
    </div>
  );
}

export default App;
